import { render, staticRenderFns } from "./RutValidation.vue?vue&type=template&id=46371928&scoped=true&"
import script from "./RutValidation.vue?vue&type=script&lang=js&"
export * from "./RutValidation.vue?vue&type=script&lang=js&"
import style0 from "./RutValidation.vue?vue&type=style&index=0&id=46371928&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46371928",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {FormInput: require('/workspace/components/Form/FormInput.vue').default,Card: require('/workspace/components/Card.vue').default})
